import React from 'react';
import { observer } from 'mobx-react-lite';
import { CellInfo } from 'react-table';
import { ISecondSourceBoxDiscrepancy, ISecondSourceTableColumn } from 'interfaces/secondSourceBox/ISecondSourcePlay';
import { PositionDict } from 'enums/PositionDictionary';
import { ClickableCell, PlayerContent, PlayerTeam, StyledReactTable } from './styles/GridViewStyles';
import NoSecondSourceData from '../NoData/NoSecondSourceData';
import AllResolved from '../AllResolved/AllResolved';
import Loader from '../Loader/Loader';

interface IProps {
  discrepancies: ISecondSourceBoxDiscrepancy[];
  onPlayerSelect: (player: ISecondSourceBoxDiscrepancy) => void;
  noDataReceived?: boolean;
  isLoading: boolean;
}

export const GridView: React.FC<IProps> = observer(({ discrepancies, onPlayerSelect, noDataReceived, isLoading }) => {
  const renderDataCell = (cellInfo: CellInfo) => {
    return cellWrapper(cellInfo.value, cellInfo);
  };

  const renderPlayerName = (cellInfo: CellInfo) => {
    const content = (
      <PlayerContent>
        <div>{cellInfo.value}</div>
        <PlayerTeam>{cellInfo.original.teamName}</PlayerTeam>
      </PlayerContent>
    );

    return cellWrapper(content, cellInfo);
  };

  const renderPosition = (cellInfo: CellInfo) => {
    const content = <div>{PositionDict[cellInfo.value]}</div>;

    return cellWrapper(content, cellInfo);
  };

  const renderPlayerId = (cellInfo: CellInfo) => {
    const trimPlayerId = cellInfo.value.split('-').pop();

    return cellWrapper(trimPlayerId, cellInfo);
  };

  const cellWrapper = (children: JSX.Element, cellInfo: CellInfo) => {
    return <ClickableCell onClick={() => onPlayerSelect(cellInfo.original)}>{children}</ClickableCell>;
  };

  const columns: ISecondSourceTableColumn[] = [
    { Header: 'Pitch #', accessor: 'playSequenceNumber', width: 100, Cell: (cellInfo: CellInfo) => renderDataCell(cellInfo) },
    { Header: 'Player', accessor: 'nameRef', width: 250, Cell: (cellInfo: CellInfo) => renderPlayerName(cellInfo) },
    { Header: 'Player ID', accessor: 'foreignId', width: 100, Cell: (cellInfo: CellInfo) => renderPlayerId(cellInfo) },
    { Header: 'Position/Base', accessor: 'position', width: 100, Cell: (cellInfo: CellInfo) => renderPosition(cellInfo) },
  ];

  return (
    <div className='box-score-table'>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {noDataReceived ? (
            <NoSecondSourceData />
          ) : (
            <>
              {discrepancies.length > 0 ? (
                <StyledReactTable
                  showPagination={false}
                  data={discrepancies}
                  columns={columns}
                  resizable={false}
                  sortable={false}
                  pageSize={discrepancies.length}
                />
              ) : (
                <AllResolved />
              )}
            </>
          )}
        </>
      )}
    </div>
  );
});
